export default "__VITE_ASSET__C7fwPp3v__"